import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  getHelp,
  getHelpSuccess,
  getHelpFailure,
  fetchUserTypes,
  fetchUserTypesSuccess,
  fetchUserTypesFaild,
  getCommissions,
  getCommissionsSuccess,
  getCommissionsFailure
 } from './page.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { PageService } from '@services/page/page.service';

@Injectable()
export class PageEffects {

  getHelp$ = createEffect(() => this.actions$.pipe(
    ofType(getHelp),
    mergeMap((action) => this.pageService.getHelp(action.key)
      .pipe(
        map(help => {
            return getHelpSuccess({ help });
        }),
        catchError((error) => {
            return of(getHelpFailure({ error }));
        })
      ))
    )
  );


  loadUserTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchUserTypes),
      mergeMap(() =>
        this.pageService.getUserTypes().pipe(
          map(res => {
            return fetchUserTypesSuccess({ userTypes: res });
          }),
          catchError(error => {
            return of(fetchUserTypesFaild({ error }));
          })
        )
      )
    )
  );

  getCommissions = createEffect(() => this.actions$.pipe(
    ofType(getCommissions),
    mergeMap((action) => this.pageService.getCommissions(action.payload)
      .pipe(
        map(data => {
          return getCommissionsSuccess({payload: data});
        }),
        catchError((error) => {
          return of(getCommissionsFailure({error}));
        })
      ))
  ))

  constructor(
    private actions$: Actions,
    private pageService: PageService
  ) {}
}
